import {
  ACTION_LOAD_WIRE_FILE__REQUEST,
  ACTION_LOAD_WIRE_FILE__SUCCESS,
  ACTION_LOAD_WIRE_FILE__FAIL,
} from '../../actionTypes';


export default (state = null, action) => {
  switch (action.type) {
    case ACTION_LOAD_WIRE_FILE__REQUEST:
    case ACTION_LOAD_WIRE_FILE__SUCCESS:
      return null;

    case ACTION_LOAD_WIRE_FILE__FAIL:
      return action.payload.error;

    default:
      return state;
  }
};
